"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-extract-finances-detail"
  }, [_c("div", {
    staticClass: "columns"
  }, [_c("div", {
    staticClass: "column"
  }, [_c("div", {
    staticClass: "header-items"
  }, [_c("h5", {
    staticClass: "grid-h title-page"
  }, [_c("button", {
    attrs: {
      nbButton: ""
    },
    on: {
      click: _vm.goBack
    }
  }, [_c("b-icon", {
    attrs: {
      icon: "arrow-left"
    }
  })], 1), _vm._v("\n          Total Requisições - " + _vm._s(_vm.service.name) + "\n        ")])])])]), _vm._v(" "), _c("div", {
    staticClass: "columns"
  }, [_c("div", {
    staticClass: "column col-filter-date is-one-quarter"
  }, [_c("div", {
    staticClass: "card-filters"
  }, [_c("h3", [_vm._v("Período:")]), _vm._v(" "), _c("div", {
    staticClass: "content-filters"
  }, [_c("app-select", {
    attrs: {
      placeholder: "Selecione o mês",
      items: _vm.listMonths,
      option: "id",
      "name-item": "name"
    },
    model: {
      value: _vm.selectMonth,
      callback: function callback($$v) {
        _vm.selectMonth = $$v;
      },
      expression: "selectMonth"
    }
  }), _vm._v(" "), _c("app-select", {
    attrs: {
      placeholder: "Selecione o ano",
      items: _vm.listYears,
      option: "id",
      "name-item": "name"
    },
    model: {
      value: _vm.selectYear,
      callback: function callback($$v) {
        _vm.selectYear = $$v;
      },
      expression: "selectYear"
    }
  })], 1), _vm._v(" "), _c("b-button", {
    staticClass: "btn-filter",
    on: {
      click: _vm.getDetailsRequests
    }
  }, [_vm._v("Filtrar")])], 1)]), _vm._v(" "), _c("div", {
    staticClass: "column col-details"
  }, [_c("div", {
    staticClass: "list-items-details"
  }, [_c("div", {
    staticClass: "header-title"
  }, [_c("h2", [_vm._v("Extrato de requisições")]), _vm._v(" "), _c("h4", [_vm._v("Data de consulta: " + _vm._s(_vm._f("dateDetail")(_vm.now)))])]), _vm._v(" "), _vm.listRequests.length ? _c("div", _vm._l(_vm.listRequests, function (item, idx) {
    return _c("div", {
      key: idx,
      staticClass: "card-detail-call",
      on: {
        click: function click($event) {
          return _vm.openDetail(item);
        }
      }
    }, [_c("span", {
      staticClass: "hour"
    }, [_vm._v("Requisições")]), _vm._v(" "), _c("h2", {
      staticClass: "detail"
    }, [_vm._v("\n              " + _vm._s(item.consumer) + "\n            ")]), _vm._v(" "), _c("div", {
      staticClass: "details-itens"
    }, [_c("span", [_vm._v("\n                Total de requisições: " + _vm._s(_vm._f("maskNumber")(item.operationsTotal)) + "\n              ")]), _vm._v(" "), _c("span", [_vm._v("\n                Total de Requisições com sucesso: " + _vm._s(_vm._f("maskNumber")(item.successTotal)) + "\n              ")]), _vm._v(" "), _c("span", [_vm._v("\n                Total de Requisições com erro: " + _vm._s(_vm._f("maskNumber")(item.errorsTotal)) + "\n              ")]), _vm._v(" "), _c("span", [_vm._v("\n                Taxa de erro: " + _vm._s(_vm._f("percent")(item.errorRate)) + "\n              ")])])]);
  }), 0) : _c("div", [_c("h4", {
    staticClass: "text-not-found"
  }, [_vm._v("Sem dados suficientes para o período selecionado.")])])])])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;